import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/analytics'

var firebaseConfig = {
  apiKey: "AIzaSyDMXsCSWCmRWaogn9wBRk0hjM19415p4Bo",
  authDomain: "avalokana-society.firebaseapp.com",
  projectId: "avalokana-society",
  storageBucket: "avalokana-society.appspot.com",
  messagingSenderId: "536241195458",
  appId: "1:536241195458:web:f47893d8fd4a3df70dae5b",
  measurementId: "G-YC9YDM4Y1X"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

// export const auth = firebase.auth();
export const db=firebase.firestore();

export default firebase;